import React from 'react';

const SimulationCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 animate-pulse">
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <div className="h-6 bg-gray-200 rounded w-3/4 mb-2 shimmer"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2 shimmer"></div>
        </div>
        <div className="h-8 w-20 bg-gray-200 rounded shimmer"></div>
      </div>

      {/* Status badges */}
      <div className="flex gap-2 mb-4">
        <div className="h-6 w-24 bg-gray-200 rounded-full shimmer"></div>
        <div className="h-6 w-32 bg-gray-200 rounded-full shimmer"></div>
      </div>

      {/* Description */}
      <div className="space-y-2 mb-4">
        <div className="h-3 bg-gray-200 rounded w-full shimmer"></div>
        <div className="h-3 bg-gray-200 rounded w-5/6 shimmer"></div>
        <div className="h-3 bg-gray-200 rounded w-4/6 shimmer"></div>
      </div>

      {/* Metrics */}
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div>
          <div className="h-3 bg-gray-200 rounded w-20 mb-1"></div>
          <div className="h-5 bg-gray-200 rounded w-16 shimmer"></div>
        </div>
        <div>
          <div className="h-3 bg-gray-200 rounded w-20 mb-1"></div>
          <div className="h-5 bg-gray-200 rounded w-16 shimmer"></div>
        </div>
        <div>
          <div className="h-3 bg-gray-200 rounded w-20 mb-1"></div>
          <div className="h-5 bg-gray-200 rounded w-16 shimmer"></div>
        </div>
      </div>

      {/* Action buttons */}
      <div className="flex gap-2">
        <div className="h-9 bg-gray-200 rounded flex-1 shimmer"></div>
        <div className="h-9 bg-gray-200 rounded flex-1 shimmer"></div>
      </div>
    </div>
  );
};

export default SimulationCardSkeleton;
